/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Probabilityofduplicate2Inputs */

const de__field_probabilityofduplicate2 = /** @type {(inputs: _Field_Probabilityofduplicate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wahrscheinlichkeit einer Dopplung`)
};

/**

* @param {_Field_Probabilityofduplicate2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_probabilityofduplicate2 = /** @type {((inputs?: _Field_Probabilityofduplicate2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Probabilityofduplicate2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_probabilityofduplicate2(inputs)
});
export { _field_probabilityofduplicate2 as "_field_probabilityOfDuplicate" }